import {gql} from 'apollo-angular';

export const GET_ALL_OFFERS = gql`
  query GetAllOffers {
    offerList {
      companyTypes {
        id
        name
      }
      schoolTypes {
        id
        name
      }
      boPartnerTypes {
        id
        name
      }
    }
  },
`;
